import * as React from 'react';

const EulaDialog: React.FC = () => {
    return null;
};

export default EulaDialog;
